/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { agreementsControllerFindAll } from "./agreementsControllerFindAll";
import { agreementsControllerFindByType } from "./agreementsControllerFindByType";
import { agreementsControllerFindVersionsByType } from "./agreementsControllerFindVersionsByType";

export function agreementsService() {
  return { agreementsControllerFindAll, agreementsControllerFindByType, agreementsControllerFindVersionsByType }
}